import Selector from "./components/Selector/Selector";
import { getLinks } from "./data/links";
import { fn } from "../../utils";
import "./App.scss";

export type AppProps = {
 logoProduct?: string;
 imageProduct?: string;
 linkAppGooglePlay?: string;
 linkAppAppleStore?: string;
 linkManual?: string;
 linkVideoYouTube?: string;
 linkGuideApp?: string;
 linkGuideMaintenance?: string;
 linkCecotecSupport?: string;
 linkGuideStart?: string;
};

export default function App(props: AppProps) {
 const {
  logoProduct = "%logoProduct%",
  imageProduct = "%imageProduct%",
  linkAppGooglePlay = "%linkAppGooglePlay%",
  linkAppAppleStore = "%linkAppAppleStore%",
  linkManual = "%linkManual%",
  linkVideoYouTube = "%linkVideoYouTube%",
  linkGuideApp = "%linkGuideApp%",
  linkGuideMaintenance = "%linkGuideMaintenance%",
  linkCecotecSupport = "%linkCecotecSupport%",
  linkGuideStart = "%linkGuideStart%",
 } = props;

 const links = getLinks({
  linkAppGooglePlay,
  linkAppAppleStore,
  linkManual,
  linkVideoYouTube,
  linkGuideApp,
  linkGuideMaintenance,
  linkCecotecSupport,
  linkGuideStart,
 });

 return (
  <div className="app landing">
   <div className="gradient" />

   <div className="header">
    {logoProduct && (
     <img src={logoProduct} className="img-logo" alt="img-logo" />
    )}
    {imageProduct && (
     <img src={imageProduct} className="img-product" alt="img-product" />
    )}
   </div>

   <div className="content">
    {links.map((item, index) => {
     console.log(item);

     if (!item.link) return null;

     return (
      <Selector
       key={index}
       {...item}
       className={fn.isValidUrl(item.link) ? "show" : ""}
      />
     );
    })}
   </div>

   <footer className="footer">
    <p className="text">www.cecotec.es</p>
   </footer>
  </div>
 );
}
